import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {ProcessFlow} from '../models/process.flow/processFlow.model';
import {JobProcessFlow} from '../models/process.flow/jobProcessFlow.model';
import {JobProcess} from '../models/process.flow/jobProcess.model';
import {Checkpoint} from '../models/process.flow/checkpoint.model';
import {map} from 'rxjs/operators';
import {User} from '../models/users/user.model';

@Injectable({
  providedIn: 'root'
})
export class ProcessFlowService {

  private PROCESS_FLOW_URL: string = environment.BASE_URL + 'process/flow';
  private JOB_PROCESS_FLOW_URL: string = environment.BASE_URL + 'job';

  constructor(private http: HttpClient) {
  }

  /**
   * GETS
   */
  public getProcessFlows(): Observable<Array<ProcessFlow>> {
    return this.http.get<Array<ProcessFlow>>(`${this.PROCESS_FLOW_URL}`).pipe();
  }

  public getProcessFlow(id: string): Observable<ProcessFlow> {
    return this.http.get<ProcessFlow>(`${this.PROCESS_FLOW_URL}/${id}`).pipe(
    );
  }

  public getJobProcessFlows(): Observable<Array<JobProcessFlow>> {
    return this.http.get<Array<JobProcessFlow>>(`${this.JOB_PROCESS_FLOW_URL}/process/flow`).pipe();
  }

  public getJobProcessFlow(jobId: string, id: string): Observable<JobProcessFlow> {
    return this.http.get<JobProcessFlow>(`${this.JOB_PROCESS_FLOW_URL}/${jobId}/process/flow/${id}`).pipe();
  }

  public getMyProcesses(): Observable<JobProcess[]> {
    return this.http.get<JobProcess[]>(`${this.PROCESS_FLOW_URL}/principal`).pipe();
  }

  public getNextProcess(): Observable<JobProcess> {
    return this.http.get<JobProcess>(`${this.PROCESS_FLOW_URL}/principal/next`).pipe();
  }

  /**
   * CREATES
   */
  public createProcessFlow(processFlow: ProcessFlow): Observable<ProcessFlow> {
    const createRequest = {
      ...processFlow,
    };
    return this.http.post<ProcessFlow>(`${this.PROCESS_FLOW_URL}`, createRequest).pipe();
  }

  /**
   * UPDATES
   */
  public updateProcessFlow(processFlow: ProcessFlow): Observable<ProcessFlow> {
    const updateRequest = {
      ...processFlow,
    };
    return this.http.patch<ProcessFlow>(`${this.PROCESS_FLOW_URL}/${processFlow.id}`, updateRequest).pipe();
  }

  public signOffProcess(process: JobProcess): Observable<JobProcess> {
    return this.http.put<JobProcess>(`${this.JOB_PROCESS_FLOW_URL}/${process.jobId}/process/flow/${process.jobProcessFlowId}/process/${process.id}`, {}).pipe();
  }

  public startProcess(process: JobProcess): Observable<JobProcessFlow> {
    return this.http.post<JobProcessFlow>(`${this.JOB_PROCESS_FLOW_URL}/${process.jobId}/process/flow/${process.jobProcessFlowId}/process/${process.id}`, {}).pipe();
  }

  public updateProcess(process: JobProcess, checkpoints: Checkpoint[]): Observable<JobProcess> {
    return this.http.patch<JobProcessFlow>(`${this.JOB_PROCESS_FLOW_URL}/${process.jobId}/process/flow/${process.jobProcessFlowId}/process/${process.id}`, {
      processCheckpoints: checkpoints
    }).pipe(
      map(jobProcessFlow => jobProcessFlow.processes.find(p => p.id === process.id))
    );
  }

  public assignProcess(process: JobProcess, user: User): Observable<JobProcessFlow> {
    return this.http.post<JobProcessFlow>(`${this.JOB_PROCESS_FLOW_URL}/${process.jobId}/process/flow/${process.jobProcessFlowId}/process/${process.id}/${user.id}`, {}).pipe();
  }

  /**
   * DELETE
   */
  public deleteProcessFlow(id: string): Observable<ProcessFlow> {
    return this.http.delete<ProcessFlow>(`${this.PROCESS_FLOW_URL}/${id}`).pipe();
  }
}
